import * as apiConfig from '../../../verticals/hotels-dweb/src/shared/config/api-config';
import * as appConfig from '../../../verticals/hotels-dweb/src/shared/config/app-config';
import * as gaConfig from '../../../verticals/hotels-dweb/src/shared/config/ga-config';
import * as infraConfig from '../../../verticals/hotels-dweb/src/shared/config/infra-config';

export const countryTextMap = {
  india: {key: 'IN', value: 'India', sec: 'domestic'},
  international: {key: 'intl', value: 'International', sec: 'international'},
};

export {apiConfig, appConfig, gaConfig, infraConfig};
